<script>
import {EventBus} from "@/eventBus";
  export default {
    name: "LastNewMovimientos",
    props: {
      color: {
        type: String,
      },
      LastNewMovimientos: {}
    },
    methods: {
      sendMessage(user) {
        EventBus.$emit("actionFn", { fn:"enviarMensaje", params:user });
      }
    },

  };
</script>

<template>

<div class="card card-custom card-custom-h-450 border-0">
    <div 
      class="d-flex justify-content-between align-items-center p-3 pb-0 color-main"
    >
      <p class="font-title font-700 mb-0">
        <img src="@/assets/img/intranet/home/icono-movimientos.svg">
        <span>Movimientos internos</span>
      </p>
    </div>
    <div class="card-body scroll max-h-400">
      <div 
        v-for="movimiento in LastNewMovimientos"
        :key="movimiento.id_movimiento"
        class="d-flex align-items-start card-shadow-light rounded p-2 mb-3">
        <div class="flex-shrink-0">
          <img
            width="40" height="40"
							class="img-object-cover rounded-circle"
            v-if="!movimiento.imagen_perfil || !/.jpg|.jpeg|.png/.test(movimiento.imagen_perfil)"
            src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
          >
          <img
            v-else
            width="40" height="40"
						class="img-object-cover rounded-circle"
            :src="movimiento.imagen_perfil"
          />
        </div>
        <div class="flex-grow-1 ms-3">
          <p class="d-grid text-secondary mb-0">
              <strong>
                {{ capitalizeFirstLetter(movimiento.usuario.primer_nombre) }}
                {{ capitalizeFirstLetter(movimiento.usuario.apellido_paterno) }}
              </strong>
              <span class="text-secondary text-opacity-75 ellipsis-custom">
                Antiguo: {{ capitalizeFirstLetter(movimiento.cargo_antiguo.nombre_cargo) }}<br/>
                Nuevo: {{ capitalizeFirstLetter(movimiento.cargo_nuevo.nombre_cargo) }}
              </span>
            </p>
        </div>
        <a href="javascript:" class="ms-2 fs-4 color-main" @click="sendMessage(movimiento.usuario)" > 
              <font-awesome-icon
                icon="fa-solid fa-comment-dots"
              ></font-awesome-icon>
            </a>
      </div>
    </div>
  </div>
</template>